(() => {
// Safety guard in case this snippet is ever included elsewhere.

const PLACEHOLDER = '[[EMAIL]]';
const EMAIL = 'vegan_high_protein@web.de';

const replaceIn = (el) => {
    if (!el) return;
    if (!el.innerHTML || el.innerHTML.indexOf(PLACEHOLDER) === -1) return;

    const emailLink = `${EMAIL}`;
    el.innerHTML = el.innerHTML.split(PLACEHOLDER).join(emailLink);
};

const run = () => {
    // Shopify policy pages typically render into this container.
    replaceIn(document.querySelector('.shopify-policy__body'));
    // Fallbacks (in case the theme wraps policy content differently).
    replaceIn(document.querySelector('.shopify-policy__container'));
    replaceIn(document.querySelector('main#MainContent'));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
} else {
    run();
}
})();